import { Outlet } from "react-router-dom";
import { useAppDispatch } from "@/sharedStore/hooks";
import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";
import { fetchStorageAddressAsync } from "../Delivery/providers/deliveryManifest/sliceServices";

const Index = () => {
  const dispatch = useAppDispatch();
  useEnhancedEffect(() => {
    dispatch(fetchStorageAddressAsync());
  }, []);
  return <Outlet />;
};

export default Index;
